import AvailablePermissionsDataTable from "../../components/dataTable/tables/AvailablePermissionsDataTable";

function AvailablePermissionsPageView() {
  return <AvailablePermissionsDataTable />;
}

export default AvailablePermissionsPageView;
